import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from 'record-it-components/form/FormGroup/FormGroup';
import { BufferedTextInput } from 'record-it-components/input/TextInput/TextInput';
import { SingleTabEditDialog, SingleTabEditDialogProps } from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { useEntityPropertyChangedCallback } from '../../../hooks/entity/useEntityPropertyChangedCallback';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { UserGroupToUsersWidget } from '../UserGroupToUsersWidget/UserGroupToUsersWidget';
export type EditUserGroupDialogProps = PropsWithoutChildren<Omit<SingleTabEditDialogProps, 'tabTitle'>> & {
  userGroup: UserGroup;
};
export const EditUserGroupDialog: FunctionComponent<EditUserGroupDialogProps> = React.memo(props => {
  const $ = _c(20);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let userGroup;
  if ($[2] !== t0) {
    ({
      userGroup,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = userGroup;
  } else {
    remainingProps = $[3];
    userGroup = $[4];
  }
  const {
    t
  } = useTranslation();
  const handleUserGroupChanged = useModifyEntityCallback(EntityName.UserGroup);
  const handleNameChanged = useEntityPropertyChangedCallback(userGroup, "name", handleUserGroupChanged);
  let t1;
  if ($[5] !== t) {
    t1 = t("components.userGroup.EditUserGroupDialog.title");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t) {
    t2 = t("entities.UserGroup.name");
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== handleNameChanged || $[10] !== t2 || $[11] !== userGroup.name) {
    t3 = <FormGroup><BufferedTextInput label={t2} value={userGroup.name} onInput={handleNameChanged} /></FormGroup>;
    $[9] = handleNameChanged;
    $[10] = t2;
    $[11] = userGroup.name;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== userGroup) {
    t4 = <FormGroup><UserGroupToUsersWidget userGroup={userGroup} /></FormGroup>;
    $[13] = userGroup;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== remainingProps || $[16] !== t1 || $[17] !== t3 || $[18] !== t4) {
    t5 = <SingleTabEditDialog tabTitle={t1} {...remainingProps}>{t3}{t4}</SingleTabEditDialog>;
    $[15] = remainingProps;
    $[16] = t1;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
});